import { Button, Space } from 'antd';
import React from 'react';

import { SPACING } from '../theme/tokens';
import AsyncFeedback from './async-feedback';

interface FormSubmitFooterProps {
  inProcess: boolean;
  updatedAt: number | undefined;
  label?: string;
  block?: boolean;
}

function FormSubmitFooter({
  inProcess,
  updatedAt,
  label = 'Save',
  block = false,
}: FormSubmitFooterProps): React.ReactElement {
  if (block) {
    return (
      <>
        <Button
          type="primary"
          htmlType="submit"
          disabled={inProcess}
          loading={inProcess}
          block
          size="large"
        >
          {label}
        </Button>
        <AsyncFeedback inProcess={inProcess} updatedAt={updatedAt} />
      </>
    );
  }

  return (
    <Space size={SPACING.sm} style={{ width: '100%' }}>
      <Button
        type="primary"
        htmlType="submit"
        disabled={inProcess}
        loading={inProcess}
        size="large"
      >
        {label}
      </Button>
      <AsyncFeedback inProcess={inProcess} updatedAt={updatedAt} />
    </Space>
  );
}

export default FormSubmitFooter;
